import React, { Component } from 'react';
import { List, ListItem, SkeletonBlock } from 'framework7-react';

class Skeleton extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  };

  render() {
    return (
      <List mediaList>
        <ListItem
          className={`skeleton-text skeleton-effect-pulse`}
          title="Title"
          subtitle="Subtitle"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi lobortis et massa ac interdum."
        >
          <SkeletonBlock style={{ width: '40px', height: '40px', 'border-radius': '50%' }} slot="media" />
        </ListItem>
      </List>
    );
  };
};

export default Skeleton;